import { gql } from '@apollo/client/core';

export const TEAM_ROLE_FIELDS = gql`
  fragment TeamRoleFields on TeamRole {
    id
    name
  }
`;

export const TEAM_ROLE_DETAILS_FIELDS = gql`
  fragment TeamRoleDetailsFields on TeamRoleDetails {
    id
    name
    permissionGroups {
      icon
      key
      label
      permissions {
        icon
        key
        label
        level
        options {
          label
          value
        }
      }
    }
    allowances {
      enabled
      key
      label
    }
  }
`;
